



var intOnly = document.getElementsByClassName("intOnly");
if (intOnly.length > 0) {
  for (var i = 0; i < intOnly.length; i++) {
    intOnly[i].addEventListener("keypress", function (event) {
      var key = event.keyCode;
      if (key < 48 || key > 57) {
        event.preventDefault();
      }
    });
  }
}

var decimalOnly = document.getElementsByClassName("decimalOnly");
if (decimalOnly.length > 0) {
  for (var i = 0; i < decimalOnly.length; i++) {
    decimalOnly[i].addEventListener("keypress", function (event) {

      var charCode = (event.which) ? event.which : event.keyCode;
      if (charCode == 46 && event.srcElement.value.split('.').length > 1) {
        event.preventDefault();
      }
      if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
        event.preventDefault();
    });
  }
}



var tables = document.querySelectorAll('.table');

tables.forEach(table => {

  var headertext = [],
    tableHeaders = table.querySelectorAll('thead th, thead td'),
    tableBody = table.querySelector('tbody');
  for (var i = 0; i < tableHeaders.length; i++) {
    var current = tableHeaders[i];
    headertext.push(current.textContent.replace(/\r?\n|\r/, ''));
  }
  if (tableBody !== null) {
    for (var i = 0, row; row = tableBody.rows[i]; i++) {
      for (var j = 0, col; col = row.cells[j]; j++) {
        if (headertext[j] != undefined) {
          col.setAttribute('data-th', headertext[j]);
        }
      }
    }
  }
});


